import { Page } from "@betomorrow/micro-stores"
import { BoxStaffApiGateway } from "@modules/boxStaff/gateway/boxStaffApiGateway"
import {
  BoxStaffActionRequest,
  BoxStaffAddInput,
  BoxStaffDetailedDto,
  BoxStaffDetailedUpadteInput,
  BoxStaffItemDto,
  BoxStaffItemDtoSchema,
} from "@modules/boxStaff/gateway/boxStaffDto"
import { ApiClient } from "@modules/core/api/client/apiClient"
import { Paginated, toPage } from "@modules/utils/paginated"

export class BoxStaffApi implements BoxStaffApiGateway {
  private baseUrl = "/box/staff"

  constructor(private api: ApiClient) {}

  async getBoxStaffs(
    page = 0,
    size = 10,
    nameFilter?: string,
    fetchArchived?: boolean,
  ): Promise<Page<BoxStaffItemDto>> {
    const result = await this.api.get<Paginated<BoxStaffItemDto>>(`${this.baseUrl}`, {
      params: { page, size, usernameOrNameSearch: nameFilter, fetchArchived },
    })

    const pageResult = toPage(result.data)

    return {
      ...pageResult,
      content: pageResult.content.map((staff) => BoxStaffItemDtoSchema.parse(staff)),
    }
  }

  async getBoxStaff(staffId: string): Promise<BoxStaffDetailedDto> {
    const resultDto = await this.api.get<BoxStaffDetailedDto>(`${this.baseUrl}/${staffId}`)
    return resultDto.data
  }

  async addBoxStaff(input: BoxStaffAddInput): Promise<BoxStaffItemDto> {
    const result = await this.api.post(`${this.baseUrl}`, { ...input })
    return BoxStaffItemDtoSchema.parse(result.data)
  }

  async responseBoxStaffInvitation(boxId: string, action: BoxStaffActionRequest): Promise<void> {
    return await this.api.post(`${this.baseUrl}/${action.toLocaleLowerCase()}`, { boxId })
  }

  async updateBoxStaff(staffId: string, input: BoxStaffDetailedUpadteInput): Promise<void> {
    await this.api.put(`${this.baseUrl}/${staffId}`, input)
  }

  async deleteBoxStaff(staffId: string): Promise<void> {
    await this.api.delete(`${this.baseUrl}/${staffId}`)
  }
}
